import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import ConfirmationDialog from '../../../components/ConfirmationDialog';
import PatientApiService from '../../../services/api/patients';

const SimilarPatientDetection = ({ active, data, proceed, cancel }) => {
  const [result, setResult] = React.useState({
    status: null,
    data: null
  });

  useEffect(() => {
    if (!!result.status || result.data) {
      return;
    }
    const patientApiService = new PatientApiService();
    setResult({ status: 'fetching', data: null });
    patientApiService.checkSimilarPatient(data).then(response => {
      setResult({
        status: 'fetched',
        data: response.data.has_similar_patient ? response.data : null
      });
    });
  }, [active, data, proceed, result, setResult]);

  useEffect(() => {
    if (active && result.status === 'fetched' && !result.data) {
      proceed();
    }
  }, [active, proceed, result]);

  if (!active || !result.status || !result.data) {
    return null;
  }

  const handleClose = value => {
    if (value) {
      proceed();
    } else {
      cancel();
    }
  };

  return (
    <ConfirmationDialog
      open
      handleClose={handleClose}
      title="Duplicate Patient"
      confirmText="Yes"
      bodyText={`${
        result.data && result.data.numeric_suffix > 1 ? 'Patients' : 'A patient'
      } with this exact name was already submitted on ${moment(
        result.data && result.data.created_at
      ).format('DD-MM-YYYY')}. Click YES to proceed, but note a '(${result.data &&
        result.data
          .numeric_suffix})' will be placed in the name to differentiate this patient from the first.`}
    />
  );
};

SimilarPatientDetection.propTypes = {
  active: PropTypes.bool,
  data: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    case_number_text: PropTypes.string,
    organization_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    user_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }).isRequired,
  proceed: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired
};

SimilarPatientDetection.defaultProps = {
  active: false
};

export default SimilarPatientDetection;
